import {
    PHOTOGRAPHERS_FETCH_REQUEST,
    PHOTOGRAPHERS_FETCH_SUCCESS,
    PHOTOGRAPHERS_FETCH_FAILURE,
    PHOTOGRAPHERS_EQ_FETCH_REQUEST,
    PHOTOGRAPHERS_EQ_FETCH_SUCCESS,
    PHOTOGRAPHERS_EQ_FETCH_FAILURE
} from './types';
import baseUrl from '../url'

const fetchPhotographersRequest = () => {
    return {
        type: PHOTOGRAPHERS_FETCH_REQUEST
    }
}

const fetchPhotographersSuccess = data => {
    return {
        type: PHOTOGRAPHERS_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchPhotographersFailure = error => {
    return {
        type: PHOTOGRAPHERS_FETCH_FAILURE,
        payload: error,
    }
}

const getPhotographers = (slug, date) => {
    return (dispatch) => {
        dispatch(fetchPhotographersRequest());
        fetch(`${baseUrl}/project_candidates/${slug}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchPhotographersSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchPhotographersFailure(error.message));
            })
    }
}

const fetchPhotographersEqRequest = (id) => {
    return {
        type: PHOTOGRAPHERS_EQ_FETCH_REQUEST,
        id: id
    }
}

const fetchPhotographersEqSuccess = (data, id) => {
    return {
        type: PHOTOGRAPHERS_EQ_FETCH_SUCCESS,
        payload: data,
        id: id
    }
}

const fetchPhotographersEqFailure = (error, id) => {
    return {
        type: PHOTOGRAPHERS_EQ_FETCH_FAILURE,
        payload: error,
        id: id
    }
}



const getPhotographersEq = (id) => {
    if (id) {
        return (dispatch) => {
            dispatch(fetchPhotographersEqRequest(id));
            fetch(`${baseUrl}/photographers/${id}/equipment`, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((response) => {
                    dispatch(fetchPhotographersEqSuccess(response, id));
                })
                .catch((error) => {
                    dispatch(fetchPhotographersEqFailure(error.message, id));
                })
        }
    } else {
        return (dispatch) => dispatch(fetchPhotographersEqSuccess({}))
    }
}

export { getPhotographers, getPhotographersEq }